import dayjs from "dayjs";
import { getDeficiencyComment } from "../../../data/DataManage";
import { LOCAL_CONSTANT } from "../../Const";

export const initCommentData = (res: any) => {
    const commentList: any[] = [];
    res.map((data: any, index: number) => {
        const commentObj = {
            id: index,
            uuid: data.uuid,                                           // uuid
            flg: "",
            create_date: dayjs(data.create_date).format("YYYY-MM-DD"), //日付
            table_name: data.table_name,                               //ページ
            column_name: data.column_name,                             //項目
            comment: data.comment,                                     //コメント
            init_comment: data.comment,                                //初期値のコメント キャンセルで戻すため
            deficiency_status: data.deficiency_status,                 //不備ステータス
            edit_status: true,                                         //編集の可否 trueが編集不可 falseが編集可
            sub_key: data.sub_key                                      //sub_key 影響度のみsub_keyが必要 JSON形式の文字列
        };
        commentList.push(commentObj);
    });
    return commentList;
};

//削除後、IDをふりなおし
export const deleteCommentData = (updateCommentTableData: any) => {
    const updateCommentList: any[] = [];
    updateCommentTableData.map((data: any, index: number) => {
        const commentObj = {
            id: index,
            uuid: data.uuid,                             // uuid
            flg: "",
            create_date: data.create_date,               //日付
            table_name: data.table_name,                 //ページ
            column_name: data.column_name,               //項目
            comment: data.comment,                       //コメント
            init_comment: data.comment,                  //初期値のコメント キャンセルで戻すため
            deficiency_status: data.deficiency_status,   //不備ステータス
            edit_status: true,                           //編集の可否 trueが編集不可 falseが編集可
            sub_key: data.sub_key                        //sub_key 影響度のみsub_keyが必要で、JSON形式の文字列
        };
        updateCommentList.push(commentObj);
    });
    return updateCommentList;
};

//不備コメント取得API
export const callApi = async (target: string, planAreaId: string | null, branch: string | null) => {
    if (target === "getDeficiencyComment" && typeof planAreaId === "string" && typeof branch === "string") {
        return await getDeficiencyComment({
            mode: target,
            plan_area_id: planAreaId,
            branch: branch
        });
    }
};

// 項目ごとの不備コメントを取得する関数
export const deficiencyCommentDetail = (listDeficiencyComment: any, tableName: string, columnName: string, subKey: string) => {
    let targetListDeficiencyComment: any[] = [];

    if (listDeficiencyComment.length === 0) {
        return targetListDeficiencyComment;
    }

    switch (tableName) {
        // 影響度
        case LOCAL_CONSTANT.TABLE.IMPACT:
            targetListDeficiencyComment = listDeficiencyComment.filter((deficiencyComment: any) => {
                // 影響度
                if (deficiencyComment.sub_key.includes("store_code") &&
                    deficiencyComment.sub_key.includes("tenpo_name") &&
                    typeof subKey !== "undefined"
                ) {
                    const parsed_sub_key = JSON.parse(deficiencyComment.sub_key);
                    const parsedSubKey = JSON.parse(subKey);
                    return (
                        deficiencyComment.table_name === LOCAL_CONSTANT.TABLE.IMPACT &&
                        deficiencyComment.column_name === columnName &&
                        parsed_sub_key.store_code === parsedSubKey.store_code &&
                        parsed_sub_key.tenpo_name === parsedSubKey.tenpo_name &&
                        LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(deficiencyComment.deficiency_status)
                    )
                // 影響度 交差点
                } else if (deficiencyComment.sub_key.includes("route_seq") &&
                            deficiencyComment.sub_key.includes("counter_uuid") &&
                            deficiencyComment.sub_key.includes("tenpo_name") &&
                            deficiencyComment.sub_key.includes("route") &&
                            deficiencyComment.sub_key.includes("intersection") &&
                            typeof subKey !== "undefined"
                ) {
                    const parsed_sub_key = JSON.parse(deficiencyComment.sub_key);
                    const parsedSubKey = JSON.parse(subKey);
                    return (
                        deficiencyComment.table_name === LOCAL_CONSTANT.TABLE.IMPACT &&
                        deficiencyComment.column_name === columnName &&
                        parsed_sub_key.route_seq === parsedSubKey.route_seq &&
                        parsed_sub_key.counter_uuid === parsedSubKey.counter_uuid &&
                        parsed_sub_key.tenpo_name === parsedSubKey.tenpo_name &&
                        parsed_sub_key.route === parsedSubKey.route &&
                        parsed_sub_key.intersection === parsedSubKey.intersection &&
                        LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(deficiencyComment.deficiency_status)
                    )
                } else {
                    return false;
                }
            });

            return targetListDeficiencyComment
    
        // 影響度以外
        default: 
            targetListDeficiencyComment = listDeficiencyComment.filter(
                (deficiencyComment: any) =>
                    deficiencyComment.table_name === tableName &&
                    deficiencyComment.column_name === columnName &&
                    LOCAL_CONSTANT.DEFICIENCY.STATUS.includes(deficiencyComment.deficiency_status)
            );

            return targetListDeficiencyComment
    }
}